var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M46 24.08C46 11.887 36.15 2 24 2S2 11.886 2 24.08c0 10.356 7.103 19.045 16.685 21.432V30.829H14.15V24.08h4.536v-2.908c0-7.515 3.39-10.999 10.74-10.999 1.394 0 3.8.275 4.783.549v6.116c-.519-.055-1.42-.082-2.541-.082-3.607 0-5.001 1.372-5.001 4.937v2.387h7.186l-1.235 6.748h-5.951V46C37.559 44.68 46 35.37 46 24.08"
  })));
};
export default SvgFacebook;